import { render, staticRenderFns } from "./SecurityKey.vue?vue&type=template&id=cf1bccf0&scoped=true&"
import script from "./SecurityKey.vue?vue&type=script&lang=ts&"
export * from "./SecurityKey.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityKey.vue?vue&type=style&index=0&id=cf1bccf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1bccf0",
  null
  
)

export default component.exports